import React$1 from 'react';
import PropTypes$1 from 'prop-types';
import Link$1 from '../../basics/Link/Link.js';
import StyledDownloads from './Downloads.style.js';

/* eslint-disable react/jsx-one-expression-per-line */

const convertFileSize = size => {
  let fileSize;

  if (size >= 1000 && size < 1000000) {
    fileSize = `${Math.round(size / 1000)} KB`;
  } else if (size >= 1000000 && size < 1000000000) {
    fileSize = `${Math.round(size / 1000000)} MB`;
  } else if (size >= 1000000000) {
    fileSize = `${Math.round(size / 1000000000)} GB`;
  }

  return fileSize;
};

const Downloads = ({
  downloads
}) => /*#__PURE__*/React$1.createElement(StyledDownloads, null, downloads.length > 0 && /*#__PURE__*/React$1.createElement("div", {
  className: "downloads__list"
}, downloads.map(({
  title,
  file
}) => /*#__PURE__*/React$1.createElement("div", {
  className: "downloads__item",
  key: file.url
}, /*#__PURE__*/React$1.createElement(Link$1, {
  href: file.url,
  icon: "download",
  className: "downloads__link",
  component: "a",
  download: true
}, "Download ", title, ' ', /*#__PURE__*/React$1.createElement("span", null, file.kind, " ", convertFileSize(file.size)))))));

Downloads.propTypes = {
  downloads: PropTypes$1.arrayOf(PropTypes$1.shape()).isRequired
};
Downloads.defaultProps = {};

export default Downloads;
